const Modals = require('sma.common/components/modals');

/* eslint-disable global-require */
const templates = {
	reuseModalBody: require('sma.applicant/tasks/partials/use_existing_modal.mustache'),
};
/* eslint-enable global-require */

const strings = require('sma.applicant/tasks/strings');

/* eslint-disable import/prefer-default-export */
export class ExistingRecordModal {
	constructor(submissionId, recordId, callback, taskType) {
		this.submissionId = submissionId;
		this.recordId = recordId;
		this.taskType = taskType;
		this.showCheckbox = taskType === 'Form';
		this.isUploadTask = taskType === 'Document';
		this.isRecommendationTask = taskType === 'Recommendation';

		this.modal = null;
		this.records = null;

		this.getRecords();
		this.callback = callback;
	}

	buildModal() {
		if (this.modal != null) return;

		let dialogMessage = strings.reuseDialogMessage;
		if (this.isUploadTask) {
			dialogMessage = strings.reuseFilesMessage;
		} else if (this.isRecommendationTask) {
			dialogMessage = strings.reuseRecommendationsMessage;
		}

		const modalBody = templates.reuseModalBody({
			records: this.records,
			strings,
			singleRecord: this.records.length === 1,
			showCheckbox: this.showCheckbox,
			dialogMessage,
		});

		const buttons = [{
			label: gettext('CANCEL'),
			cls: 'btn',
			handler: (modal) => {
				modal.hide();
			},
		}, {
			label: gettext('Add data'),
			cls: 'btn btn-primary',
			handler: this.applyExistingData.bind(this),
		}];

		if (this.isUploadTask) {
			buttons[1].label = gettext('Add Files');
		} else if (this.isRecommendationTask) {
			buttons[1].label = gettext('Add Recommendations');
		}

		this.modal = new Modals.ContentModal(
			modalBody, {
				title: gettext('Reuse data'),
				autoShow: false,
				destroyOnClose: false,
				size: 'md',
				buttons,
			},
		);
	}

	hideErrors() {
		if (this.modal == null) return;
		this.modal.modalBody.find('.sma-global-task-reuse-alert.errorlist').fadeOut(0);
	}

	showErrors(message) {
		if (!this.modal.modalBody.find('.sma-global-task-reuse-alert.errorlist').length) {
			this.modal.modalBody.find('.sma-global-task-reuse-dialog')
				.after('<label class="sma-global-task-reuse-alert mt-2 mb-0 errorlist"></label>');
		}
		this.modal.modalBody.find('.sma-global-task-reuse-alert.errorlist').html(message).fadeOut(0).fadeIn();
	}

	getRecords() {
		$.get(
			reverse('task-global-reuse', { submission_id: this.submissionId, task_record_id: this.recordId }),
			{},
			(response) => {
				if (response.success) {
					this.records = response.records;

					this.buildModal();
					if (this.callback !== undefined) {
						this.callback(this.records);
					}
				}
			},
			'json',
		);
	}

	applyExistingData() {
		let selectedRecord = this.modal.modalBody.find('select[name="previous-task-records"]').val();
		const overwriteData = this.modal.modalBody.find('input[name="overwrite-previous"]').prop('checked');

		if (this.records.length === 1) {
			selectedRecord = this.records[0].id;
		}

		$.post(
			reverse('task-global-reuse', { submission_id: this.submissionId, task_record_id: this.recordId }),
			JSON.stringify({
				record: selectedRecord,
				overwriteData,
			}),
			(response) => {
				if (response.success) {
					window.location = response.location;
				} else {
					this.showErrors(response.message);
				}
			},
			'json',
		);
	}
}
